import Vue from "vue";
import store from "@/store";
import App from "./App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import mask from "vue-the-mask";
import moment from "moment";
import "moment/locale/pt-br";
import "@/apps/shared";
import { db, storage, app, analytics } from "./apps/shared/firebase";
import run from "./apps/shared/Onoff";
import VueHtml2pdf from "vue-html2pdf";
import VuejsClipper from "vuejs-clipper";
import VueCropper from "vue-cropper";
import "driver.js/dist/driver.css";

Vue.use(VueCropper);

export const EventBus = new Vue();

Vue.use(VueHtml2pdf);
Vue.use(mask);
Vue.use(VuejsClipper);
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

const theme = {
  primary: "#FF9800",
  secondary: "#FF9800",
  light: true,
  dark: false,
  third: "#47cf72",
  icon_drawer: "#f2f2f2",
  icon_color: "#e1673c",
  app_bar: "#444",
  background: "rgba(0, 0, 0, 0)",
  grey: "#f2f2f2",
  drawer: "#1173ff",
};

Vue.prototype.$theme = theme;
Vue.prototype.$db = db;
Vue.prototype.$app = app;
Vue.prototype.$storage = storage;
Vue.prototype.$analytics = analytics;
Vue.prototype.$run = run;

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
